export default "__VITE_ASSET__CVSn$68z__"